import { useMemo, useState } from "react";
import { Input } from "../ui/input";
import { Checkbox } from "../ui/checkbox";
import { Search, ListChecks, Check } from "lucide-react";

// Selettore destinatari: liste salvate (toggle) + singoli partner (checkbox). alreadyIds = partner già contattati.
export const PartnerSendPicker = ({ partners, lists, selectedIds, setSelectedIds, selectedListIds, setSelectedListIds, alreadyIds = [], testPrefix = "send" }) => {
  const [q, setQ] = useState("");
  const already = useMemo(() => new Set(alreadyIds), [alreadyIds]);
  const listById = useMemo(() => Object.fromEntries(lists.map((l) => [l.id, l])), [lists]);

  const toggleList = (l) => {
    const on = selectedListIds.includes(l.id);
    const nextLists = on ? selectedListIds.filter((x) => x !== l.id) : [...selectedListIds, l.id];
    const stillCovered = new Set(nextLists.flatMap((id) => listById[id]?.partner_ids || []));
    const next = on ? selectedIds.filter((pid) => !l.partner_ids.includes(pid) || stillCovered.has(pid)) : [...new Set([...selectedIds, ...l.partner_ids])];
    setSelectedListIds(nextLists);
    setSelectedIds(next);
  };
  const togglePartner = (id) => setSelectedIds(selectedIds.includes(id) ? selectedIds.filter((x) => x !== id) : [...selectedIds, id]);

  const visible = partners.filter((p) => !q || `${p.name} ${p.provincia || ""}`.toLowerCase().includes(q.toLowerCase()));
  const selectAllVisible = () => setSelectedIds([...new Set([...selectedIds, ...visible.map((p) => p.id)])]);

  return (
    <div className="space-y-3">
      {lists.length > 0 && (
        <div>
          <p className="text-[11px] uppercase tracking-wide text-slate-500 font-semibold mb-1.5 flex items-center gap-1"><ListChecks className="h-3.5 w-3.5" /> Liste salvate</p>
          <div className="flex flex-wrap gap-2">
            {lists.map((l) => {
              const on = selectedListIds.includes(l.id);
              return (
                <button key={l.id} type="button" data-testid={`${testPrefix}-list-${l.id}`} onClick={() => toggleList(l)}
                  className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium transition-colors ${on ? "bg-primary text-white border-primary" : "bg-white text-slate-700 border-slate-300 hover:border-primary"}`}>
                  {on && <Check className="h-3 w-3" />}{l.name} <span className={on ? "text-white/70" : "text-slate-400"}>({l.partner_ids.length})</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
      <div className="flex items-center gap-2">
        <div className="relative flex-1">
          <Search className="h-3.5 w-3.5 absolute left-2.5 top-2.5 text-slate-400" />
          <Input data-testid={`${testPrefix}-search`} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca partner o provincia…" className="h-8 pl-8 text-sm" />
        </div>
        <button type="button" data-testid={`${testPrefix}-select-visible`} onClick={selectAllVisible} className="text-xs text-primary font-medium hover:underline whitespace-nowrap">Seleziona visibili</button>
        <button type="button" data-testid={`${testPrefix}-clear`} onClick={() => { setSelectedIds([]); setSelectedListIds([]); }} className="text-xs text-slate-500 hover:underline whitespace-nowrap">Svuota</button>
      </div>
      <div data-testid={`${testPrefix}-partner-list`} className="max-h-56 overflow-y-auto rounded-md border border-slate-200 divide-y divide-slate-100 bg-white">
        {visible.length === 0 && <p className="text-xs text-slate-400 p-3">Nessun partner trovato.</p>}
        {visible.map((p) => {
          const on = selectedIds.includes(p.id);
          return (
            <label key={p.id} data-testid={`${testPrefix}-partner-${p.id}`} className={`flex items-center gap-3 px-3 py-2 cursor-pointer text-sm ${on ? "bg-primary/5" : "hover:bg-slate-50"}`}>
              <Checkbox checked={on} onCheckedChange={() => togglePartner(p.id)} />
              <span className="flex-1 text-slate-800">{p.name}{p.provincia && <span className="text-slate-400 text-xs ml-1.5">({p.provincia})</span>}</span>
              {already.has(p.id) && <span data-testid={`${testPrefix}-already-${p.id}`} className="text-[10px] rounded-full bg-amber-50 text-amber-700 border border-amber-200 px-2 py-0.5">già contattato</span>}
            </label>
          );
        })}
      </div>
      <p className="text-xs text-slate-500" data-testid={`${testPrefix}-count`}>{selectedIds.length} partner selezionati</p>
    </div>
  );
};
